export default __webpack_public_path__ + "static/media/camera.c94f81c2.svg";